<block-ui></block-ui>

  <div class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column">

        </div>
        <div class="card-toolbar">
          <button type="button" id="btnSetPass" class="btn btn-sm me-3 btn-light-primary"
                  (click)="showEditTemplateModal(EditTemplateModal)">
            <i class="fa fa fa-edit" aria-hidden="true"></i>
            <span>{{utilityService.getResourceValue("Edit")}}</span>
          </button>
          <button type="button" id="btnSetPass" class="btn btn-sm me-3 btn-light-primary"
                  (click)="showSendEmailModal(SendEmailModal)">
            <i class="fa fa-paper-plane"></i>{{utilityService.getResourceValue("SendEmail")}}
          </button>
          <button type="button" id="btnSetPass" class="btn btn-sm me-3 btn-light-primary"
                  (click)="showTestSendEmailModal(TestSendEmailModal)">
            <i class="fa fa-bars"></i>{{utilityService.getResourceValue("TestSendEmail")}}
          </button>
          <button type="button" id="btnSetPass" class="btn btn-sm me-3 btn-light-primary"
                  (click)="showTestSendSMSModal(TestSendSMSModal)">
            <i class="fa fa-envelope-open-text sms"></i>{{utilityService.getResourceValue("TestSendSMS")}}
          </button>
          <button type="button" id="btnSetPass" class="btn btn-sm me-3 btn-primary" *ngIf="!ProductionMode"
                  (click)="showGenerateCodeByIdModal(TemplateInfo, GenerateCodeModal)">
            <i class="fa fa-bars"></i>{{utilityService.getResourceValue("GenerateCode")}}
          </button>
          <button type="button" id="btnSetPass" class="btn btn-sm me-3 btn-primary" *ngIf="!ProductionMode"
                  (click)="showGenerateUpdateCodeByIdModal(TemplateInfo,GenerateCodeModal)">
            <i class="fa fa-key"></i>{{utilityService.getResourceValue("GenerateUpdateCode")}}
          </button>

        </div>
      </div>
      <div class="card-body py-3">
        <div class="row">
          <div class="col-xl-6 mb-10">
            <div class="d-flex h-100 align-items-center ">
              <!--begin::Option-->
              <div class="w-100 d-flex flex-column flex-center rounded-3 bg-light py-10 px-10 h-100">
                <!--begin::Heading-->
                <div class="mb-7 d-flex justify-content-between w-100">
                  <!--begin::Title-->
                  <a [routerLink]="['/Admin/Notifications/EditEmail',TemplateInfo.id,'en']"
                     routerLinkActive="router-link-active" class="text-primary mb-5 fw-boldest fs-2">
                    English:
                    {{TemplateInfo.emailtemplateinfo.emailSubject.english}}
                  </a>

                  <a [routerLink]="['/Admin/Notifications/EditEmail',TemplateInfo.id,'en']"
                     routerLinkActive="router-link-active" class="btn btn-sm btn-light-primary btn-icon">
                    <i class="fa fa-pen"></i>
                  </a>

                </div>
                <div class="w-100 mb-10">
                  <!--begin::Item-->
                  <div class="d-flex align-items-center mb-5">
                    <div class="fw-bold fs-6 text-gray-800 flex-grow-1 pe-3">
                      <div innerHTML="{{TemplateInfo.emailtemplateinfo.templateEmailBaseHeader.english}}">
                      </div>
                      <div innerHTML="{{TemplateInfo.emailtemplateinfo.emailHtmlHeadSection.english}}">
                      </div>
                      <div innerHTML="{{TemplateInfo.emailtemplateinfo.emailBody.english}}">
                      </div>
                      <div class="table-dark-skin pt-7" innerHTML="{{TemplateInfo.emailtemplateinfo.templateEmailBaseFooter.english}}">
                      </div>
                    </div>
                  </div>
                </div>

                <!--end::Select-->
              </div>
              <!--end::Option-->
            </div>
          </div>
          <div class="col-xl-6 mb-10">
            <div class="d-flex h-100 align-items-center">
              <!--begin::Option-->
              <div class="w-100 d-flex flex-column flex-center rounded-3 bg-light py-10 px-10 h-100">
                <!--begin::Heading-->
                <div class="mb-7 d-flex justify-content-between w-100">
                  <!--begin::Title-->
                  <a [routerLink]="['/Admin/Notifications/EditEmail',TemplateInfo.id,'ar']"
                     routerLinkActive="router-link-active" class="text-primary mb-5 fw-boldest fs-2">
                    Arabic:
                    {{TemplateInfo.emailtemplateinfo.emailSubject.arabic}}
                  </a>
                  <a [routerLink]="['/Admin/Notifications/EditEmail',TemplateInfo.id,'ar']"
                     routerLinkActive="router-link-active" class="btn btn-sm btn-light-primary btn-icon">
                    <i class="fa fa-pen"></i>
                  </a>
                </div>
                <div class="w-100 mb-10">
                  <!--begin::Item-->
                  <div class="d-flex align-items-center mb-5">
                    <div class="fw-bold fs-6 text-gray-800 flex-grow-1 pe-3 ar">
                      <div innerHTML="{{TemplateInfo.emailtemplateinfo.templateEmailBaseHeader.arabic}}">
                      </div>
                      <div innerHTML="{{TemplateInfo.emailtemplateinfo.emailHtmlHeadSection.arabic}}">
                      </div>
                      <div innerHTML="{{TemplateInfo.emailtemplateinfo.emailBody.arabic}}">
                      </div>
                      <div class="table-dark-skin pt-7" innerHTML="{{TemplateInfo.emailtemplateinfo.templateEmailBaseFooter.arabic}}">
                      </div>
                    </div>
                  </div>
                </div>


                <!--end::Select-->
              </div>
              <!--end::Option-->
            </div>
          </div>
          <div class="col-xl-6">
            <div class="card bg-light">
              <div class="card-header border-0 py-10">
                <div class="card-title text-primary mb-5 fw-boldest fs-2">
                  English:SMS
                </div>
                <div class="card-toolbar">
                  <a class="btn btn-sm btn-light-primary btn-icon" [routerLink]="['/Admin/Notifications/EditSMS',TemplateInfo.id,'en']"
                     routerLinkActive="router-link-active">
                    <span class="">
                      <i class="fa fa-pen font-size-18"></i>
                    </span>
                  </a>

                </div>
              </div>
              <div class="card-body d-flex align-items-center justify-content-center">
                <div class="iphone">
                  <span class="position-absolute mobile-txt">{{TemplateInfo.smstemplateinfo.sms.english}}</span>
                </div>
              </div>
            </div>

          </div>
          <div class="col-xl-6">
            <div class="card bg-light">
              <div class="card-header border-0 py-10">
                <div class="card-title text-primary mb-5 fw-boldest fs-2">
                  English:SMS
                </div>
                <div class="card-toolbar">
                  <a class="btn btn-sm btn-light-primary btn-icon" [routerLink]="['/Admin/Notifications/EditSMS',TemplateInfo.id,'ar']"
                     routerLinkActive="router-link-active">
                    <span class="">
                      <i class="fa fa-pen font-size-18"></i>
                    </span>
                  </a>
                </div>
              </div>
              <div class="card-body d-flex align-items-center justify-content-center">
                <div class="iphone">
                  <span class="position-absolute mobile-txt ar">  {{TemplateInfo.smstemplateinfo.sms.arabic}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




<!-- send Email Modal -->
<ng-template #SendEmailModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("SendEmailTemplate")}}</h1>
    </div>
    <form [formGroup]="SendEmailForm"
          (ngSubmit)="sendEmail()">
      <div class="row">
        <div class="col-md-12">
          <BBSF-TextArea [options]="To" [group]="SendEmailForm">
          </BBSF-TextArea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-DropdownList [options]="Language" [group]="SendEmailForm">
          </BBSF-DropdownList>
        </div>
        <div class="col-md-12">
          <BBSF-DropdownList [options]="EmailServiceProvider" [group]="SendEmailForm">
          </BBSF-DropdownList>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseSendEmailForm id="CloseSendEmailForm" type="button" class="btn btn-light me-3 btn-sm"
                (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("Send")}}</button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Test sms Email Modal -->
<ng-template #TestSendSMSModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("TestSendSMS")}}</h1>
    </div>
    <form [formGroup]="TestSendSMSForm"
          (ngSubmit)="testSendSMS()">

      <div class="row">
        <div class="col-md-12">
          <BBSF-Phone [options]="TestSendSMSTo" [group]="TestSendSMSForm">
          </BBSF-Phone>
        </div>

        <div class="col-md-12">
          <BBSF-DropdownList [options]="TestSMSServiceProvider" [group]="TestSendSMSForm">
          </BBSF-DropdownList>
        </div>

      </div>

      <div>
        <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
          <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
            <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
          </span>
          <div class="d-flex flex-stack flex-grow-1">
            <div class="fw-bold">
              <div class="fs-6 text-gray-700">
                Kindly note that these attributes are reserved
              </div>
            </div>
          </div>
        </div>
        <ul class="list-unstyled">
          <li class="mb-2">NameEN</li>
          <li class="mb-2">NameAR</li>
          <li class="mb-2">Subject</li>
          <li class="mb-2">LangKey</li>
          <li class="mb-2">Mobile</li>
          <li class="mb-2">Email</li>
          <li class="mb-2">Date</li>
          <li class="mb-2">Time</li>
          <li class="mb-2">DateTime</li>
        </ul>
      </div>
      <div class="text-center pt-7">
        <button #CloseTestSendSMSForm id="CloseTestSendSMSForm" type="button" class="btn btn-light me-3 btn-sm"
                (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("Send")}}</button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Test Send Email Modal -->
<ng-template #TestSendEmailModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("TestSendEmail")}}</h1>
    </div>
    <form [formGroup]="TestSendEmailForm"
          (ngSubmit)="testSendEmail()">
      <div class="row">

        <div class="col-md-12">
          <BBSF-TextArea [options]="TestSendEmailTo" [group]="TestSendEmailForm">
          </BBSF-TextArea>
        </div>

        <div class="col-md-12">
          <BBSF-DropdownList [options]="TestEmailServiceProvider" [group]="TestSendEmailForm">
          </BBSF-DropdownList>
        </div>
      </div>
      <div>
        <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
          <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
            <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
          </span>
          <div class="d-flex flex-stack flex-grow-1">
            <div class="fw-bold">
              <div class="fs-6 text-gray-700">
                {{utilityService.getResourceValue("KeyMapNote")}}
              </div>
            </div>
          </div>
        </div>
        <ul class="list-unstyled">
          <li class="mb-2">NameEN</li>
          <li class="mb-2">NameAR</li>
          <li class="mb-2">Subject</li>
          <li class="mb-2">LangKey</li>
          <li class="mb-2">Mobile</li>
          <li class="mb-2">Email</li>
          <li class="mb-2">Date</li>
          <li class="mb-2">Time</li>
          <li class="mb-2">DateTime</li>
        </ul>
      </div>
      <div class="text-center pt-7">
        <button #CloseTestSendEmailForm id="CloseTestSendEmailForm" type="button" class="btn btn-light me-3 btn-sm"
                (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("Send")}}</button>
      </div>
    </form>
  </div>
</ng-template>

<!-- edit Modal -->
<ng-template #EditTemplateModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("EditTemplate")}}</h1>
    </div>
    <form [formGroup]="EditTemplateForm" (ngSubmit)="editTemplate()">
      <div class="row">
        <div class="col-md-12">
          <BBSF-MultiLingualTextBox [options]="EditMultiLingualName" [group]="EditTemplateForm"></BBSF-MultiLingualTextBox>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-TextBox [options]="EditDescriptionInEnglish" [group]="EditTemplateForm">
          </BBSF-TextBox>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-TextBox [options]="EditDescriptionInArabic" [group]="EditTemplateForm">
          </BBSF-TextBox>
        </div>
      </div>
      <div class="row" *ngIf="!ProductionMode">
        <div class="col-md-12">
          <BBSF-TextBox [options]="EditSysName" [group]="EditTemplateForm">
          </BBSF-TextBox>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-DropdownList [options]="EditOrganization" [group]="EditTemplateForm">
          </BBSF-DropdownList>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-DropdownList [options]="EditLanguageMode" [group]="EditTemplateForm">
          </BBSF-DropdownList>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-DropdownList [options]="EditCategory" [group]="EditTemplateForm">
          </BBSF-DropdownList>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-DropdownList [options]="EditMasterLayout" [group]="EditTemplateForm">
          </BBSF-DropdownList>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-CheckBox [options]="EditIsEmail" [group]="EditTemplateForm">
          </BBSF-CheckBox>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-CheckBox [options]="EditIsSms" [group]="EditTemplateForm">
          </BBSF-CheckBox>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <BBSF-CheckBox [options]="EditEnableIntensiveLogging" [group]="EditTemplateForm">
          </BBSF-CheckBox>
        </div>
      </div>

      <div class="text-center pt-7">
        <button #CloseEditTemplateModal id="CloseEditTemplateModal" type="button" class="btn btn-light me-3 btn-sm"
                (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
      </div>
    </form>
  </div>
</ng-template>

<!-- GenerateCode Modal -->
<ng-template #GenerateCodeModal let-modal>
  <div class="modal-header pb-0 border-0 justify-content-end">
    <h5 class="modal-title" id="exampleModalLabel"></h5>
    <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
      <span class="svg-icon svg-icon-1">
        <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
      </span>
    </button>
  </div>
  <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
    <div class="mb-13 text-center">
      <h1 class="mb-3">{{utilityService.getResourceValue("GenerateCode")}}</h1>
    </div>
    <form [formGroup]="GenerateCodeForm">

      <div class="Row">
        <BBSF-TextArea [options]="GenerateCodeTextArea" [group]="GenerateCodeForm" #GenerateCodeInput>
        </BBSF-TextArea>
      </div>
      <div class="text-center pt-7">
        <button #CloseGenerateCodeModal id="CloseGenerateCodeModal" type="button" class="btn btn-light me-3 btn-sm"
                (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" class="btn btn-primary btn-sm" (click)="copyInputMessage()">
          {{utilityService.getResourceValue("CopyToClipboard")}}
        </button>
      </div>
    </form>
  </div>
</ng-template>

